import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  Grid,
  Paper,
  Snackbar,
  Alert
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../services/api';

interface UserData {
  name: string;
  email: string;
  specialty: string;
  crm: string;
  phone: string;
  address: string;
  bio: string;
  workdays: string;
  workhours: string;
}

const MyProfileForm: React.FC = () => {
  const { user, updateUser } = useAuth();
  const [formData, setFormData] = useState<UserData>({
    name: '',
    email: '',
    specialty: '',
    crm: '',
    phone: '',
    address: '',
    bio: '',
    workdays: '',
    workhours: ''
  });
  const [message, setMessage] = useState({ type: 'success', text: '' });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await api.get('/users/me');
        setFormData(response.data);
      } catch (error) {
        console.error('Erro ao carregar dados do usuário:', error);
        setMessage({ type: 'error', text: 'Erro ao carregar dados do usuário' });
        setOpen(true);
      }
    };

    fetchUserData();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await api.put('/users/me', formData);
      updateUser(response.data);
      setMessage({ type: 'success', text: 'Dados atualizados com sucesso!' });
      setOpen(true);
    } catch (error) {
      console.error('Erro ao atualizar dados:', error);
      setMessage({ type: 'error', text: 'Erro ao atualizar dados' });
      setOpen(true);
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 3, maxWidth: 800, mx: 'auto', mt: 3 }}>
      <Typography variant="h5" component="h1" gutterBottom>
        Meus Dados
      </Typography>
      
      <Box component="form" onSubmit={handleSubmit} noValidate>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Nome"
              name="name"
              value={formData.name}
              onChange={handleChange}
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Especialidade"
              name="specialty"
              value={formData.specialty}
              onChange={handleChange}
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="CRM"
              name="crm"
              value={formData.crm}
              onChange={handleChange}
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Telefone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Endereço"
              name="address"
              value={formData.address}
              onChange={handleChange}
              margin="normal"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Biografia"
              name="bio"
              multiline
              rows={4}
              value={formData.bio}
              onChange={handleChange}
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Dias de Trabalho"
              name="workdays"
              value={formData.workdays}
              onChange={handleChange}
              margin="normal"
              placeholder="Ex: Segunda a Sexta"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Horário de Trabalho"
              name="workhours"
              value={formData.workhours}
              onChange={handleChange}
              margin="normal"
              placeholder="Ex: 08:00 às 18:00"
            />
          </Grid>
        </Grid>

        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            size="large"
          >
            Salvar Alterações
          </Button>
        </Box>
      </Box>

      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setOpen(false)}
          severity={message.type === 'success' ? 'success' : 'error'}
          sx={{ width: '100%' }}
        >
          {message.text}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default MyProfileForm;
